import type { FaireProductEntity } from "../../entity_types/product";

export const p_vwz27btfsx: FaireProductEntity = {
  token: "p_vwz27btfsx",
  type: "product",
  name: "Black Eyed Susans Kitchen Towel",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/4fee829f4ed15376670a63d4216b85ab4f7f53a57e8f21d91384c176050d9503.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3ac6fb2056ec4ea799b09ee21763739b2d60b913b1c685b5ab0cd1bf5616eae0.jpeg",
    "https://cdn.faire.com/fastly/9cef619a7f582de9b62604d8f3e83ca497963498dd33658fe13fee8b64d754fc.jpeg",
    "https://cdn.faire.com/fastly/50ea4e28619a39db299390f695c8ef07f616939a6fbca7e5102e1efb6b1ba88c.jpeg",
    "https://cdn.faire.com/fastly/9694b1725a337b0f281c49c75589bccf2ca82324941ce63f555b8f657db0be01.jpeg",
    "https://cdn.faire.com/fastly/2ac546fe4065c55109ebcd70824b2ed90655dafae782eb5ac02fa15ce2fa5c74.jpeg",
    "https://cdn.faire.com/fastly/5ecbaf37eda859aa702177bad99325be0295e0417191f6eac939807a8f74ffa9.jpeg"
  ],
  priceDollars: 8,
  description: "A microfiber kitchen towel from our Garden Collection featuring an all-over design displaying a calming scene of bees in a field of black eyed susans. The black eyed susans design is replicated from original artwork painted onto burlap canvas, giving the art a unique depth and texture. Double-sided towel displays a coordinating stripe pattern on the back that offers multiple display options with a cotton tape hanger in the corner for hanging. Our Black Eyed Susans kitchen towel is conveniently machine washable for easy cleaning. Microfiber towel is packaged on a cardboard hanger with hole to easily display on store rack. A garden-themed kitchen accessory that easily adds personal style to any kitchen.",
  tags: [],
  msrpDollars: 15.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:12.213Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
